import bannerImg from './banners/woman-helping-man-gym.jpg';

export default {
    id: 'anamnese-corrida-avancado',
    title: 'Anamnese de corredor avançado',
    description: 'Ficha detalhada para atletas experientes focados em performance, tempo de prova e periodização.',
    indicatedFor: 'Assessorias de corrida',
    stepsCount: 2,
    questionsSummary: ['Melhor tempo (PR)', 'Volume semanal', 'Objetivo de prova', 'Histórico de lesões'],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: 'Anamnese de corredor avançado',
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Seus dados de performance',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Continuar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: 'Nome completo',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'text',
                        label: 'Qual é o seu melhor tempo (PR) na distância principal que você compete?',
                        description: 'Ex: 10 km em 48min, Meia maratona em 1h55.',
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'number',
                        label: 'Qual é o seu volume médio semanal de corrida (em km)?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'choices',
                        label: 'Qual é o seu próximo objetivo de prova?',
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: '10 km' },
                                { id: 'opt-2', label: 'Meia maratona (21 km)' },
                                { id: 'opt-3', label: 'Maratona (42 km)' },
                                { id: 'opt-4', label: 'Ultra trail' },
                                { id: 'opt-5', label: 'Melhorar PR na mesma distância' },
                            ],
                        },
                    },
                ],
            },
            {
                order: 2,
                title: 'Histórico e condicionamento',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Enviar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'yes_no_maybe',
                        label: 'Você já sofreu alguma lesão que interrompeu seu treinamento no último ano?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'text',
                        label: 'Descreva seu treino atual (dias por semana, tipos de sessão, treinos longos).',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'text',
                        label: 'Quais são os seus maiores gargalos de performance hoje?',
                        description: 'Ex: resistência, velocidade, recuperação, mental.',
                        required: false,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
};
